var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDanceMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Party-Music-Dance-Woman--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Party Music Dance Woman Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.49 3.72a1 1 0 0 0 -0.12 -1.41L21.2 0.48a1 1 0 0 0 -1.64 0.66l-0.26 2.34a0.24 0.24 0 0 1 -0.3 0.22 2.07 2.07 0 1 0 2 2.44 15 15 0 0 0 0.29 -2.46 0.24 0.24 0 0 1 0.16 -0.2 0.23 0.23 0 0 1 0.25 0l0.39 0.32a1 1 0 0 0 1.4 -0.08Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.05 11.7a1 1 0 0 0 -0.59 -1.29l-2 -0.74a1 1 0 0 0 -1 0.19 1 1 0 0 0 -0.3 1l0.42 1.77a0.28 0.28 0 0 1 -0.12 0.28 1.67 1.67 0 0 0 -0.6 0.58 1.69 1.69 0 1 0 3.08 0.49c-0.14 -0.6 -0.25 -1.1 -0.34 -1.5a0.12 0.12 0 0 1 0 -0.14 0.14 0.14 0 0 1 0.15 0 1 1 0 0 0 1.3 -0.64Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87 17.35a0.31 0.31 0 0 1 0.2 0.11 0.24 0.24 0 0 1 0 0.22l-1.24 4.15a1.5 1.5 0 0 0 1 1.86 1.52 1.52 0 0 0 0.42 0.06 1.49 1.49 0 0 0 1.44 -1.08L9 18.46l0.39 -1.33a0.27 0.27 0 0 1 0.15 -0.13 0.24 0.24 0 0 1 0.24 0.08l0.45 0.52a2.21 2.21 0 0 1 0.47 1.9l-0.39 2a1.5 1.5 0 0 0 1.14 1.79 1.12 1.12 0 0 0 0.32 0 1.52 1.52 0 0 0 1.47 -1.17l0.6 -2.7a4.78 4.78 0 0 0 -0.63 -3.85 0.24 0.24 0 0 1 0 -0.22 0.25 0.25 0 0 1 0.14 -0.16c0.4 -0.16 0.9 -0.43 1 -0.7a1 1 0 0 0 -0.35 -0.99L9.72 9.7a0.24 0.24 0 0 1 0.12 -0.43l3.23 -0.54A1.5 1.5 0 0 0 14.3 7a1.53 1.53 0 0 0 -1.73 -1.23l-3.24 0.54a10.27 10.27 0 0 0 -5.55 2.84l-3.06 3a1.5 1.5 0 0 0 1.05 2.57 1.53 1.53 0 0 0 1.06 -0.44L5 12.13a0.24 0.24 0 0 1 0.3 0 0.26 0.26 0 0 1 0.11 0.28l-1 3.79a0.92 0.92 0 0 0 0.34 0.91 2 2 0 0 0 1.12 0.24Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27 4.24a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDanceMusic);
export default ForwardRef;